import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import style from './index.scss';
import { Layout, List, Space, message, Modal } from 'antd';
import styled from 'styled-components';
import {
  fetchTypologiesOfScenario,
  removeTypologyFromScenario
} from '../../../../../redux/actions/trm/trmDashboard';
import DynamicProperties from '../../../../common/DynamicProperties';
const { Content } = Layout;

const CustomModal = styled(Modal)`
  .ant-modal-header {
    padding: 12px;
  }
  .ant-modal-content {
    padding: 12px 12px 0px 12px;
  }

  /* Reduce padding for the modal body content */
  .ant-modal-body {
    padding: 12px;
  }
  h6 {
    padding-top: 12px;
    padding-left: 36px;
  }
`;

/**
 * Typologies List Class
 */
class TypologiesList extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      scenarioTypologiesList: [],
      defaultCurrent: 1,
      pageSize: 20,
      isLoading: false,
      isModalVisible: false
    };
  }

  /**
   * componentDidMount
   */
  componentDidMount() {
    this.props.fetchTypologiesOfScenarioData({
      scenarioID: this.props.scenarioID,
      page: this.state.defaultCurrent - 1,
      pageSize: this.state.pageSize
    });
  }

  /**
   * getDerivedStateFromProps
   * @param nextProps
   * @returns {null|{trmTypologies: ([]|*[]|{isLoading: boolean, data: {typologies: [], totalCount: number}, error: null}|{isLoading: boolean, data: {typologies: [], totalCount: number}, error: null}|{isLoading: boolean, data: {typologies: [], totalCount: number}, error: null}|{isLoading: boolean, data, error: null}|*)}}
   */
  static getDerivedStateFromProps(nextProps) {
    const { trmDashboard } = nextProps;

    if (trmDashboard && trmDashboard.scenarioTypologiesList) {
      return {
        scenarioTypologiesList: trmDashboard.scenarioTypologiesList
      };
    }
    return null;
  }

  onPaginationChange = (page, pageSize) => {
    this.setState({ defaultCurrent: page, pageSize });
    this.props.fetchTypologiesOfScenarioData({
      scenarioID: this.props.scenarioID,
      page: page - 1,
      pageSize
    });
  };

  onRemoveTypology = (event, typologyID) => {
    this.setState({ isLoading: true });
    this.props.removeTypologyFromScenario({
      typologyIds: [typologyID],
      scenarioID: this.props.scenarioID
    });

    setTimeout(() => {
      this.setState({ isLoading: false });
    }, 1000);
  };

  //Configure typology dyn props func
  showConfigureModal = (title, typologyId) => {
    this.setState({ isModalVisible: true, title: title, typologyId });
  };

  handleOk = () => {
    this.setState({ isModalVisible: false });
  };

  handleCancel = () => {
    this.setState({ isModalVisible: false });
  };
  //typology dyn props func --- ends

  //Modal component of Typology Dyn props
  dynPropsModalComponent = () => {
    const { title, typologyId } = this.state;
    const screenWidth = window.innerWidth;
    const modalWidth = `${(85 * screenWidth) / 100}px`;
    return (
      <CustomModal
        id="typology-modal"
        title="Dynamic Properties"
        visible={this.state.isModalVisible}
        destroyOnClose
        onOk={this.handleOk}
        onCancel={this.handleCancel}
        width={modalWidth}
        footer={false}>
        <h6>Typology Name: {title}</h6>
        <DynamicProperties
          subModule="typology"
          moduleId="3"
          runInstanceId={this.props.scenarioID}
          typologyId={typologyId}
        />
      </CustomModal>
    );
  };

  //Modal component of Typology Dyn props -- ends

  render() {
    const {
      showRemoveOption = true,
      executed = false,
      showTypologydynProps = true,
      dynpropsTabAccess = false
    } = this.props;
    const { scenarioTypologiesList, defaultCurrent, pageSize } = this.state;
    const { isLoading = true, data = null } = scenarioTypologiesList || {};
    let typologyList = [];
    let typologyCount = 0;
    if (!isLoading && data) {
      typologyList = data.typologies;
      typologyCount = data?.typologies?.length;
    }

    return (
      <Layout className="layout">
        <Content>
          <Space
            size={5}
            direction="vertical"
            style={{ width: '100%', backgroundColor: 'white' }}>
            <Content>
              <div className={style.typologyListHeader}>
                <div>Typology Name</div>
                {showRemoveOption && <div>Action</div>}
              </div>
              <List
                size="small"
                bordered
                loading={this.state.isLoading || isLoading}
                pagination={{
                  total: typologyCount,
                  defaultCurrent: defaultCurrent,
                  onChange: this.onPaginationChange,
                  pageSize
                }}
                dataSource={typologyList}
                renderItem={(item, index) => {
                  const { id, title } = item || {};
                  return (
                    <List.Item
                      style={{
                        boxShadow:
                          'inset 0px -1px 1px #D0D7E3, inset 1px 0px 1px #D0D7E3, inset -1px 0px 1px #D9D9D9',
                        backgroundColor: 'white'
                      }}>
                      <div className={style.typologiesListItems}>
                        <div>{title}</div>
                        <div className={style.actionItems}>
                          {showTypologydynProps && dynpropsTabAccess && (
                            <div
                              id="configure-div"
                              onClick={() => {
                                this.showConfigureModal(title, id);
                              }}>
                              Configure
                            </div>
                          )}
                          {showTypologydynProps && dynpropsTabAccess && (
                            <span style={{ margin: '0 5px' }}>|</span>
                          )}
                          {showRemoveOption && (
                            <div
                              onClick={(event) => {
                                if (!executed) this.onRemoveTypology(event, id);
                              }}
                              className={executed && style.disable}>
                              Remove
                            </div>
                          )}
                        </div>
                      </div>
                    </List.Item>
                  );
                }}
              />
            </Content>
          </Space>
          {this.state.isModalVisible && this.dynPropsModalComponent()}
        </Content>
      </Layout>
    );
  }
}

/**
 * mapStateToProps
 * @param state
 * @param ownProps
 * @returns {{typologyListingDashboard: trmDashboard}}
 */
function mapStateToProps(state, ownProps = {}) {
  return {
    trmDashboard: state.trmDashboard
  };
}

/**
 * mapDispatchToProps
 * @param dispatch
 * @param ownProps
 * @returns {{dispatch: *}}
 */
function mapDispatchToProps(dispatch, ownProps = {}) {
  return {
    fetchTypologiesOfScenarioData: (payload) => {
      dispatch(fetchTypologiesOfScenario(payload));
    },
    removeTypologyFromScenario: (payload) => {
      dispatch(removeTypologyFromScenario(payload));
    }
  };
}

TypologiesList.propTypes = {
  scenarioID: PropTypes.number,
  dynpropsTabAccess: PropTypes.bool
};

export default connect(mapStateToProps, mapDispatchToProps)(TypologiesList);
